import api from '../api';

class DownloadSocialImage {
  constructor() {
    this.apiBase = process.env.REACT_APP_API_BASE_73;
  }

  async gerarImagemSocial(fileId, idRede, personalizacao) {
    try {
      // Monta o objeto com todos os parâmetros necessários
      const requestBody = {
        texto: personalizacao.texto || '',
        posicao_texto: personalizacao.posicao_texto || 'bottom',
        cor_texto: personalizacao.cor_texto || '#FFFFFF',
        tamanho_texto: personalizacao.tamanho_texto || 24,
        moldura_id: personalizacao.moldura_id,
        nome_moldura: personalizacao.nome_moldura || '',
        logo_id: personalizacao.logo_id,
        posicao_logo: personalizacao.posicao_logo || 'top-right',
        tamanho_logo: personalizacao.tamanho_logo || 15
      };

      console.log('URL da requisição:', `${this.apiBase}${fileId}?id_rede=${idRede}`);
      console.log('Dados enviados:', requestBody);

      const response = await api.post(
        `${this.apiBase}${fileId}?id_rede=${idRede}`,
        requestBody,
        { responseType: 'blob' }  // Indica que esperamos uma resposta binária
      );

      console.log('Resposta recebida:', response);

      // Se a resposta for um blob, significa que a imagem está pronta
      if (response.data instanceof Blob) {
        const blob = response.data;
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `social_${fileId}.jpg`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);
        return { status: 'completed' };
      } else if (response.status === 202) {
        // Processamento assíncrono iniciado
        const data = response.data;
        console.log('Processamento assíncrono iniciado:', data);
        return {
          status: 'processing',
          taskId: data.task_id,
          checkStatusUrl: data.check_status_url
        };
      } else {
        throw new Error('Resposta inesperada do servidor');
      }
    } catch (error) {
      console.error('Erro ao gerar imagem social:', error);
      throw error;
    }
  }

  async monitorarStatus(taskId) {
    try {
      const response = await api.get(`${this.apiBase}${taskId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar status:', error);
      throw error;
    }
  }

  async processarImagem(fileId, idRede, personalizacao) {
    try {
      // Inicia o processamento
      const resultado = await this.gerarImagemSocial(fileId, idRede, personalizacao);

      if (resultado.status === 'processing') {
        // Monitora o status do processamento
        return new Promise((resolve, reject) => {
          const verificarStatus = async () => {
            try {
              const status = await this.monitorarStatus(resultado.taskId);
              
              if (status.status === 'concluido') {
                // Processamento concluído, fazer nova requisição para download
                const downloadResult = await this.gerarImagemSocial(fileId, idRede, personalizacao);
                resolve(downloadResult);
              } else if (status.status === 'erro') {
                reject(new Error(status.erro || 'Erro no processamento'));
              } else {
                // Continuar monitorando
                setTimeout(verificarStatus, 2000);
              }
            } catch (error) {
              reject(error);
            }
          };

          verificarStatus();
        });
      } else {
        return resultado;
      }
    } catch (error) {
      console.error('Erro no processamento da imagem:', error);
      throw error;
    }
  }
}

export default new DownloadSocialImage(); 